import { Link } from 'react-router-dom';
import { bySortIndex } from '../lib/sortIndex';
import type { Profile } from '../lib/types';
import { useSyncedStore } from '../store/synced';

// Profile picker. Per plan/03 §A. Home screen as primary picker:
// 1–3 profiles → one column; 4+ → two columns. Today's progress badge is
// deferred until the task screen lands (no progress data yet).
export function HomePage() {
  const tree = useSyncedStore((s) => s.tree);
  const profiles = (tree?.profiles ?? []).slice().sort(bySortIndex);

  const columns = profiles.length <= 3 ? 1 : 2;

  return (
    <main className="home">
      <Link to="/settings" className="settings-icon" aria-label="Asetukset">
        <span aria-hidden="true">⚙️</span>
      </Link>
      <h1 className="home-title">Aamusankari</h1>
      <ul className={`profile-grid cols-${columns}`}>
        {profiles.map((p) => (
          <li key={p.id}>
            <ProfileCard profile={p} />
          </li>
        ))}
      </ul>
    </main>
  );
}

function ProfileCard({ profile }: { profile: Profile }) {
  return (
    <Link
      to={`/p/${profile.id}`}
      className="profile-card"
      style={{ background: profile.color }}
      aria-label={`Aloita: ${profile.name}`}
    >
      <span className="profile-card-avatar" aria-hidden="true">
        {profile.avatarEmoji}
      </span>
      <span className="profile-card-name">{profile.name}</span>
    </Link>
  );
}
